






























import { Component, Vue, Inject } from 'vue-property-decorator';


@Component({})
export default class Videos extends Vue {
	keyword = '';
	items = [{
		asin: 'jVIpEay1J-c',
		published: 'Published on Jan 13, 2019',
		views: '3,915 views',
		text: 'Best BARBERS in the World 2019 Amazing Hairstyles',
		link: 'https://www.youtube.com/embed/jVIpEay1J-c'
	}, {
		asin: 'pjhuZGu6TPg',
		published: 'Published on Sep 21, 2018',
		views: '28,633 views',
		text: '11 Best BARBERS in the World Viral Instagram Hairstyle Videos PART 2',
		link: 'https://www.youtube.com/embed/pjhuZGu6TPg'
	}, {
		asin: '-dNrV7vKV9E',
		published: 'Published on Dec 4, 2018',
		views: '3,448,171 views',
		text: '10 Best BARBERS in the World Viral Instagram Hairstyle Videos',
		link: 'https://www.youtube.com/embed/-dNrV7vKV9E'
	}];

	search(): void {
		let url = 'https://www.amazon.com/gp/search?ie=UTF8&tag=vhusnullin-20&linkCode=ur2&linkId=64668162dc1f4c0b1ddc4f25eba9f8a4&camp=1789&creative=9325&index=tools&keywords=' + this.keyword;
		window.location.href = url;
	}
}
